import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ActivityLogService from '~/api/services/activityLogs';
import { DownloadService } from '~/api/services/downloadFiles';
import i18n from '~/components/i18n';
import Layout from '~/components/Layout';
import TableComponent from '~/components/TableComponent';
import { RouteTypes } from '~/routes/constants';
import { handleErrors } from '~/utils/helpers';

const getTableColumnHeaders = () => [
  {
    name: i18n.t('Date'),
    key: 'date',
    type: 'dateRibbon',
    format: 'MMM YYYY'
  },
  {
    name: i18n.t('Rows'),
    key: 'rows'
  },
  {
    name: i18n.t('Created at'),
    key: 'createdAt',
    type: 'date',
    format: 'DD.MM.YYYY HH:mm'
  },
  {
    name: i18n.t('Actions')
  }
]

const History: React.FC = () => {
  const { t } = useTranslation()
  const [isBusy, setIsBusy] = useState(false)
  const [historyData, setHistoryData] = useState(null)
  const actions = [
    {
      popupMessage: i18n.t('Download'),
      type: 'icon',
      name: 'cloud download',
      size: 'large',
      actionType: 'download'
    }
  ]

  useEffect(() => {
    fetchHistoryData()
  }, [])

  async function fetchHistoryData() {
    setIsBusy(false)
    try {
      const response = await ActivityLogService.getActivityLogsHistory()
      setHistoryData(response.data)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  async function handleDownloadHistory(row) {
    setIsBusy(true)
    try {
      await DownloadService.downloadFile(`activity-log-histories/${row.id}/download`, t('History'))
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  async function handleActionClick(row, type) {
    switch (type) {
      case 'download':
        return handleDownloadHistory(row)
      default:
        return
    }
  }

  function renderTable() {
    return <TableComponent
      removePagination
      actions={actions}
      handleClickAction={(row, type) => handleActionClick(row, type)}
      tableColumnHeaders={getTableColumnHeaders()}
      total={total}
      rows={rows}
    />
  }

  const { total, rows } = historyData ? historyData : { total: 0, rows: [] }

  return <Layout
    segmented
    close={RouteTypes.DAIRY_FACTORY_PRICE_ACTIVITY_LOGS}
    isBusy={isBusy}
    title={t('History')}
  >
    {historyData && renderTable()}
  </Layout>
}
export default History